import React, { Component } from 'react';
import {
    Alert,
    Container,
    Button, Row, Col,
    FormGroup,
    Input,
    Label
} from 'reactstrap';
import ReactTable from 'react-table';
import PermissionWrapper from '../../auth/PermissionWrapper';
import "./Reports.css";

import CompanyContext from '../../auth/CompanyContext';

const SSRS_API_BASE_URL = `${process.env.REACT_APP_PORTAL_API_URL}/api/crm`;
const SSRS_REPORT_ENDPOINT = `${SSRS_API_BASE_URL}/ssrsRequest`;
const SSRS_BLOB_ENDPOINT = `${SSRS_API_BASE_URL}/ssrsGetPdfBlob`;
const SSRS_DELETE_BLOB_ENDPOINT = `${SSRS_API_BASE_URL}/ssrsDeletePdfBlob`;
const POLL_INTERVAL_MS = 2000;
const MAX_POLL_ATTEMPTS = 120;
// const HARDCODED_ENTITY_LIST = '12707852';
// const HARDCODED_FOLDER = 'ExampleSSRSProject';
// const HARDCODED_PARAM_STRING = 'PortfolioList`12707852';
// const HARDCODED_REPORT = 'helloworld';
const PORTFOLIO_SUMMARY_REPORT = 'Portfolio Summary';
const PORTFOLIO_SUMMARY_SINGLE_DATE = '09-15-2025';

const normalizeValue = (value) => String(value || '').trim().toLowerCase();

class SSRSReports extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            reportsIsLoading: true,
            reportState: {
                isGlobal: false,
                isLatest: false,
                reportID: 0
            },
            reports: [
                // {
                //     name: 'Hello World',
                //     folder: HARDCODED_FOLDER,
                //     report: HARDCODED_REPORT
                // },
                // {
                //     name: PORTFOLIO_SUMMARY_REPORT,
                //     folder: HARDCODED_FOLDER,
                //     report: PORTFOLIO_SUMMARY_REPORT,
                //     requiresAccount: true
                // }
            ],
            submitLoading: false,
            pollLoading: false,
            submitError: '',
            submitSuccess: '',
            status: '',
            activeReportName: '',
            selectedReportName: '',
            selectedReport: null,
            selectedReportDefaults: [],
            selectedReportParameters: [],
            selectedReportParameterValues: {},
            selectedReportParametersLoading: false,
            selectedReportParametersError: '',
            invalidParameters: {},
            genericDates: [],
            genericDateToggles: {},
            pdfUrl: null,
            pdfFileName: '',
            accountMappings: [],
            accountMappingsLoading: false,
            selectedAccountNumber: '',
            accountMappingsPageSize: localStorage.getItem('ssrsAccountMappingsPageSize') != null
                ? parseInt(localStorage.getItem('ssrsAccountMappingsPageSize'))
                : 20
        };
        this.checkPdfBlobTimerId = null;
        this.mounted = false;

        this.defaultColumn = {
            headerStyle: { textAlign: 'left' },
            style: { textAlign: 'left' }
        };
        this.leftAlignedHeaderProps = () => ({ style: { textAlign: 'left' } });
        this.leftAlignedCellProps = (state, rowInfo) => {
            const report = rowInfo?.original;
            const reportName = report?.report || report?.name || '';
            const isSelectedReport = reportName && reportName === this.state.selectedReportName;

            return {
                style: {
                    textAlign: 'left',
                    color: isSelectedReport ? '#fff' : undefined
                }
            };
        };

        this.accountMappingColumns = [
            {
                Header: '',
                id: 'selected',
                width: 60,
                sortable: false,
                filterable: false,
                Cell: row => {
                    const accountNumber = this.getAccountNumber(row.original?.account);
                    const selectionValue = row.original?.accountNumberDisplay || accountNumber;
                    return (
                        <input
                            type="radio"
                            name="ssrsSelectedAccountNumber"
                            checked={this.state.selectedAccountNumber === selectionValue}
                            disabled={!accountNumber}
                            onClick={event => event.stopPropagation()}
                            onChange={() => this.selectAccountNumber(selectionValue)}
                            style={{ position: 'relative', marginTop: 0 }}
                        />
                    );
                }
            },
            {
                Header: 'Account',
                accessor: 'displayName',
                headerStyle: { textAlign: 'left' },
                style: { textAlign: 'left' },
                filterable: true
            },
            {
                Header: 'Account #',
                id: 'accountNumber',
                accessor: 'accountNumberDisplay',
                headerStyle: { textAlign: 'left' },
                style: { textAlign: 'left' },
                filterable: true,
                width: 120,
                sortMethod: (a, b, desc) => {
                    const aNum = parseInt(this.getAccountNumber(a));
                    const bNum = parseInt(this.getAccountNumber(b));

                    if (Number.isNaN(aNum) && Number.isNaN(bNum)) return 0;
                    if (Number.isNaN(aNum)) return desc ? -1 : 1;
                    if (Number.isNaN(bNum)) return desc ? 1 : -1;

                    if (aNum === bNum) return String(a).localeCompare(String(b));
                    return aNum > bNum ? 1 : -1;
                }
            }
        ];

        this.reportColumns = [
            {
                Header: 'Reports',
                accessor: 'name',
                filterable: false
            }
        ];

    }

    componentDidMount = () => {
        this.mounted = true;
        this.getParameterDefaults();
        this.getAccountMappings();
        this.getGenericDates();
    }

    componentDidUpdate(prevProps) {
        if (!this.hasCompanyPortalDatabase(prevProps.companySettings) && this.hasCompanyPortalDatabase()) {
            this.getParameterDefaults();
            this.getAccountMappings();
            this.getGenericDates();
        }
    }

    componentWillUnmount() {
        this.mounted = false;
        this.clearBlobPolling();
        if (this.state.pdfUrl) window.URL.revokeObjectURL(this.state.pdfUrl);
    }

    buildSsrsQueryUrl = (endpoint, params = {}) => {
        const searchParams = new URLSearchParams(params);
        return `${SSRS_API_BASE_URL}/${endpoint}?${searchParams.toString()}`;
    }

    getParameterDefaults = () => {
        if (!this.props.idToken || !this.getHeaderDatabase() || !this.hasCompanyPortalDatabase()) {
            this.setState({ reportsIsLoading: false });
            return;
        }

        this.setState({ loading: true, reportsIsLoading: true });

        fetch(`${process.env.REACT_APP_PORTAL_API_URL}/api/crm/ssrsGetParameterDefaults`, {
            method: 'GET',
            headers: this.getRequestHeaders()
        })
            .then(response => response.json())
            .then(results => {
                if (!this.mounted) return;

                if (results.code === 200) {
                    const parameterList = results.data || [];
                    this.setState({ parameterList });
                    this.getReportStyles(parameterList);
                } else {
                    console.log('Error getting report defaults');
                    this.setState({ loading: false, reportsIsLoading: false });
                }
            })
            .catch(error => {
                console.error(error);
                if (!this.mounted) return;
                this.setState({ loading: false, reportsIsLoading: false });
            });
    }

    getReportStyles = (parameterList = []) => {
        if (!this.hasCompanyPortalDatabase()) {
            this.setState({ loading: false, reportsIsLoading: false });
            return;
        }

        this.setState({ loading: true });

        fetch(`${process.env.REACT_APP_PORTAL_API_URL}/api/crm/ssrsGetReportStyles`, {
            method: 'GET',
            headers: this.getRequestHeaders()
        })
            .then(response => response.json())
            .then(results => {
                if (!this.mounted) return;

                if (results.code === 200) {
                    const reportStyles = results.data || [];
                    const reportStylesText = [];

                    reportStyles.forEach(reportStyle => {
                        if (reportStylesText.indexOf(reportStyle.style) === -1) {
                            reportStylesText.push(reportStyle.style);
                        }
                    });
                    reportStylesText.push('Custom');

                    this.setState({ reportStyles, reportStylesText });
                    this.getReportList(parameterList, reportStyles);
                } else {
                    console.log('Error getting report styles');
                    this.setState({ loading: false, reportsIsLoading: false });
                }
            })
            .catch(error => {
                console.error(error);
                if (!this.mounted) return;
                this.setState({ loading: false, reportsIsLoading: false });
            });
    }

    getReportList = (parameterList = [], reportStyles = []) => {
        if (!this.hasCompanyPortalDatabase()) {
            this.setState({ loading: false, reportsIsLoading: false });
            return;
        }

        fetch(this.buildSsrsQueryUrl('ssrsGetReportsWithTitle', {
            // company: this.getSsrsDatabase(),
            includeStandard: this.props.includeStandard,
            includeCustom: this.props.includeCustom
        }), {
            method: 'GET',
            headers: this.getRequestHeaders(null)
        })
            .then(response => response.json())
            .then(results => {
                if (!this.mounted) return;

                const reportNames = [];
                let reports = (results.data || []).reduce((acc, reportInResponse) => {
                    const rawName = reportInResponse.name || '';

                    if (rawName.includes('_Landscape') || rawName.includes('_Portrait')) {
                        const splitName = rawName.split('_');
                        if (!reportNames.includes(splitName[0])) {
                            reportNames.push(splitName[0]);
                            acc.push({
                                name: splitName[0],
                                key: reportInResponse.key,
                                type: reportInResponse.reportType,
                                title: reportInResponse.reportTitle,
                                adjustableLayout: true
                            });
                        }
                    } else {
                        acc.push({
                            name: rawName,
                            key: reportInResponse.key,
                            type: reportInResponse.reportType,
                            title: reportInResponse.reportTitle
                        });
                    }

                    return acc;
                }, []);

                reports = reports.map(report => {
                    const style = reportStyles.find(item => item.report === report.name)?.style || 'Custom';
                    const title = parameterList.find(item => (
                        item.reportName === report.name &&
                        item.paramName === 'ReportTitle'
                    ))?.value || report.title || report.name;

                    return {
                        ...report,
                        style,
                        title,
                        report: report.name,
                        // folder: report.folder,
                        // requiresAccount: report.name === PORTFOLIO_SUMMARY_REPORT
                    };
                });

                const customReports = reports
                    .filter(report => report.style === 'Custom')
                    .sort((a, b) => a.name > b.name ? 1 : -1);
                const standardReports = reports
                    .filter(report => report.style !== 'Custom')
                    .sort((a, b) => a.name > b.name ? 1 : -1);

                const nextReports = customReports.concat(standardReports);
                this.setState({
                    reports: nextReports.length > 0 ? nextReports : this.state.reports,
                    loading: false,
                    reportsIsLoading: false
                });
            })
            .catch(err => {
                console.error(err);
                if (!this.mounted) return;
                this.setState({ loading: false, reportsIsLoading: false });
            });
    }

    clearBlobPolling = () => {
        if (this.checkPdfBlobTimerId) {
            clearInterval(this.checkPdfBlobTimerId);
            this.checkPdfBlobTimerId = null;
        }
    }

    getHeaderDatabase = () => {
        return this.context.company || '';
    }

    hasCompanyPortalDatabase = (companySettings = this.props.companySettings) => {
        return String(companySettings?.CompanyPortalDatabase || '').trim() !== '';
    }

    getSsrsDatabase = () => {
        return this.props.companySettings?.CompanyPortalDatabase || '';
    }

    getRequestHeaders = (contentType = 'application/json') => {
        const headers = {
            'Authorization': 'Bearer ' + (this.props.idToken || ''),
            'X-Database': this.getHeaderDatabase()
        };

        if (contentType) headers['Content-Type'] = contentType;
        return headers;
    }

    getDateTime = () => {
        const now = new Date();
        return [
            now.getMonth() + 1,
            now.getDate(),
            now.getFullYear(),
            now.getHours(),
            now.getMinutes(),
            now.getSeconds()
        ].join('');
    }

    getCurrentUserEmail = () => {
        return this.props.userData?.CustomEmail
            || this.props.userData?.['Email Address']
            || this.props.userData?.email
            || this.props.user?.email
            || '';
    }

    getAccountMappings = () => {
        if (!this.props.idToken || !this.getHeaderDatabase() || !this.hasCompanyPortalDatabase()) {
            this.setState({ accountMappings: [] });
            return;
        }

        this.setState({ accountMappingsLoading: true });

        fetch(`${process.env.REACT_APP_PORTAL_API_URL}/api/crm/householdinfo`, {
            method: 'GET',
            headers: this.getRequestHeaders()
        })
            .then(results => results.json())
            .then(results => {
                if (!this.mounted) return;

                const seenRows = new Set();
                const dedupedAccountMappings = (results?.data || [])
                    .map(item => ({
                        ...item,
                        accountNumber: this.getAccountNumber(item?.account),
                        displayName: String(item?.displayName || '').replace(' - ' + item?.account, '')
                    }))
                    .filter(item => {
                        const rowKey = [
                            normalizeValue(item.displayName),
                            normalizeValue(item.accountNumber)
                        ].join('|');
                        if (seenRows.has(rowKey)) return false;
                        seenRows.add(rowKey);
                        return true;
                    });
                const accountNumberCounts = dedupedAccountMappings.reduce((acc, item) => {
                    if (!item.accountNumber) return acc;
                    acc[item.accountNumber] = (acc[item.accountNumber] || 0) + 1;
                    return acc;
                }, {});
                const accountMappings = dedupedAccountMappings.map(item => ({
                    ...item,
                    accountNumberDisplay: accountNumberCounts[item.accountNumber] > 1
                        ? String(item.account || '').trim()
                        : item.accountNumber
                }));

                this.setState(prevState => {
                    const portfolioOptions = this.getPortfolioParameterOptionsFromMappings(accountMappings);
                    const selectedReportParameterValues = { ...prevState.selectedReportParameterValues };
                    let selectedAccountNumber = prevState.selectedAccountNumber;

                    const selectedReportParameters = prevState.selectedReportParameters.map(parameter => {
                        if (!parameter.isPortfolioParameter) return parameter;

                        let value = selectedReportParameterValues[parameter.name];
                        const hasValue = Array.isArray(value) ? value.length > 0 : Boolean(value);
                        if (!hasValue && portfolioOptions.length > 0) {
                            value = parameter.multiValue ? [portfolioOptions[0].value] : portfolioOptions[0].value;
                            selectedReportParameterValues[parameter.name] = value;
                            selectedAccountNumber = parameter.multiValue ? value[0] : value;
                        }

                        return { ...parameter, options: portfolioOptions, value };
                    });

                    return {
                        accountMappings,
                        selectedAccountNumber,
                        selectedReportParameterValues,
                        selectedReportParameters
                    };
                });
            })
            .catch(() => {
                if (!this.mounted) return;
                this.setState({
                    accountMappings: [],
                    submitError: 'Unable to load account mappings.'
                });
            })
            .finally(() => {
                if (!this.mounted) return;
                this.setState({ accountMappingsLoading: false });
            });
    }

    getGenericDates = () => {
        if (!this.props.idToken || !this.getHeaderDatabase() || !this.hasCompanyPortalDatabase()) {
            this.setState({ genericDates: [] });
            return;
        }

        fetch(this.buildSsrsQueryUrl('ssrsGetAllGenericDates'), {
            method: 'GET',
            headers: this.getRequestHeaders(null)
        })
            .then(response => response.json())
            .then(results => {
                if (!this.mounted) return;

                const genericDates = (results?.data || []).map(date => ({
                    value: date.value,
                    label: date.description ? `${date.label} - ${date.description}` : date.label,
                    code: date.label
                }));

                this.setState({ genericDates });
            })
            .catch(err => {
                console.error(err);
                if (!this.mounted) return;
                this.setState({ genericDates: [] });
            });
    }

    setAccountMappingsPageSize = (pageSize) => {
        const parsed = parseInt(pageSize);
        const safePageSize = Number.isNaN(parsed) ? 20 : parsed;
        localStorage.setItem('ssrsAccountMappingsPageSize', safePageSize);
        this.setState({ accountMappingsPageSize: safePageSize });
    }

    getAccountNumber = (account) => {
        return String(account || '')
            .trim()
            .replace(/^p/i, '')
            .replace(/\D/g, '');
    }

    selectAccountNumber = (accountNumber) => {
        if (!accountNumber) return;

        this.setState(prevState => {
            const portfolioParameter = prevState.selectedReportParameters.find(parameter => (
                parameter.name === 'PortfolioList' || parameter.name === 'PortfolioTest'
            ));
            if (!portfolioParameter) {
                return { selectedAccountNumber: accountNumber };
            }
            const portfolioValue = portfolioParameter.multiValue ? [accountNumber] : accountNumber;

            return {
                selectedAccountNumber: accountNumber,
                selectedReportParameterValues: {
                    ...prevState.selectedReportParameterValues,
                    [portfolioParameter.name]: portfolioValue
                },
                selectedReportParameters: prevState.selectedReportParameters.map(parameter => (
                    parameter.name === portfolioParameter.name
                        ? { ...parameter, value: portfolioValue }
                        : parameter
                ))
            };
        });
    }

    selectReport = (report) => {
        const reportName = report?.report || report?.name || '';
        if (!reportName) return;

        this.clearBlobPolling();
        if (this.state.pdfUrl) window.URL.revokeObjectURL(this.state.pdfUrl);

        this.setState({
            selectedReportName: reportName,
            selectedReport: report,
            selectedReportDefaults: [],
            selectedReportParameters: [],
            selectedReportParameterValues: {},
            invalidParameters: {},
            genericDateToggles: {},
            selectedReportParametersLoading: true,
            selectedReportParametersError: '',
            submitError: '',
            submitSuccess: '',
            status: '',
            activeReportName: '',
            pdfUrl: null,
            pdfFileName: '',
            submitLoading: false,
            pollLoading: false
        }, () => {
            this.getSelectedReportParameters(report);
        });
    }

    getSelectedReportApiName = (report) => {
        const reportName = report?.report || report?.name || '';
        return report?.adjustableLayout ? `${reportName}_Landscape` : reportName;
    }

    getSelectedReportParameters = async (report) => {
        const reportName = this.getSelectedReportApiName(report);
        if (!reportName || !this.props.idToken || !this.getHeaderDatabase() || !this.hasCompanyPortalDatabase()) {
            this.setState({
                selectedReportParametersLoading: false,
                selectedReportParametersError: 'Missing report, token, or database.'
            });
            return;
        }

        try {
            const defaultsResponse = await fetch(this.buildSsrsQueryUrl('ssrsGetParameterDefaults', {
                report: reportName,
                includeGlobals: true
            }), {
                method: 'GET',
                headers: this.getRequestHeaders(null)
            });
            const defaultsResults = await defaultsResponse.json();

            if (!this.mounted || this.state.selectedReportName !== (report?.report || report?.name || '')) return;
            if (defaultsResults.code !== 200) {
                throw new Error('Error getting report defaults.');
            }

            const parametersResponse = await fetch(this.buildSsrsQueryUrl('ssrsGetReportParameters', {
                report: reportName
            }), {
                method: 'GET',
                headers: this.getRequestHeaders(null)
            });
            const parametersResults = await parametersResponse.json();

            if (!this.mounted || this.state.selectedReportName !== (report?.report || report?.name || '')) return;
            if (parametersResults.code !== 200) {
                throw new Error('Error getting report parameters.');
            }

            const selectedReportParameters = await this.buildSelectedReportParameters(
                parametersResults.data || [],
                defaultsResults.data || [],
                reportName
            );
            const selectedReportParameterValues = selectedReportParameters.reduce((acc, parameter) => {
                acc[parameter.name] = parameter.value;
                return acc;
            }, {});
            const genericDateToggles = selectedReportParameters.reduce((acc, parameter) => {
                if (parameter.usesGenericDate) acc[parameter.name] = true;
                return acc;
            }, {});

            this.setState({
                selectedReportDefaults: defaultsResults.data || [],
                selectedReportParameters,
                selectedReportParameterValues,
                genericDateToggles,
                selectedReportParametersLoading: false,
                selectedReportParametersError: ''
            });
        } catch (err) {
            console.error(err);
            if (!this.mounted || this.state.selectedReportName !== (report?.report || report?.name || '')) return;

            this.setState({
                selectedReportDefaults: [],
                selectedReportParameters: [],
                selectedReportParameterValues: {},
                genericDateToggles: {},
                selectedReportParametersLoading: false,
                selectedReportParametersError: err.message || 'Error loading report parameters.'
            });
        }
    }

    buildSelectedReportParameters = async (parameters = [], defaults = [], reportName = '') => {
        const selectedReportParameters = await Promise.all(parameters
            .filter(parameter => parameter.ParamName !== 'database')
            .map(parameter => this.buildSelectedReportParameter(parameter, defaults, reportName)));

        return selectedReportParameters
            .filter(Boolean)
            .sort((a, b) => {
                const aSort = parseInt(a.sortOrder);
                const bSort = parseInt(b.sortOrder);

                if (Number.isNaN(aSort) && Number.isNaN(bSort)) return 0;
                if (Number.isNaN(aSort)) return 1;
                if (Number.isNaN(bSort)) return -1;
                return aSort - bSort;
            });
    }

    buildSelectedReportParameter = async (parameter, defaults = [], reportName = '') => {
        try {
            const name = parameter.ParamName;
            const type = this.getReportParameterType(parameter);
            const isPortfolioParameter = name === 'PortfolioList' || name === 'PortfolioTest';
            let options = isPortfolioParameter
                ? this.getPortfolioParameterOptions()
                : this.getReportParameterOptions(parameter);

            if (!isPortfolioParameter && parameter.DynamicValidValues === 'True' && options.length === 0) {
                options = await this.getDynamicParameterOptions(
                    parameter.ReportName || reportName,
                    name
                );
            }

            const shouldLoadDynamicDefault = parameter.DynamicDefaultValue === 'True'
                && parameter.ParamName !== 'equityAssetClass';
            const dynamicDefaultValue = shouldLoadDynamicDefault
                ? await this.getDynamicParameterDefaultValue(parameter.ReportName || reportName, name)
                : '';
            const rawDefaultValue = this.getRawReportParameterDefaultValue(parameter, defaults, dynamicDefaultValue);
            let defaultValue = this.getReportParameterDefaultValue(
                parameter,
                defaults,
                options,
                type,
                dynamicDefaultValue
            );
            if (isPortfolioParameter) {
                defaultValue = this.state.selectedAccountNumber
                    ? this.state.selectedAccountNumber
                    : (defaultValue || options[0]?.value || '');
                if (parameter.MultiValue === 'True') {
                    defaultValue = Array.isArray(defaultValue) ? defaultValue : [defaultValue];
                } else {
                    defaultValue = Array.isArray(defaultValue) ? (defaultValue[0] || '') : defaultValue;
                }
            }
            const usesGenericDate = type === 'DateTime'
                && typeof rawDefaultValue === 'string'
                && rawDefaultValue.length === 4;

            return {
                name,
                label: parameter.Prompt || name,
                type,
                options,
                value: defaultValue,
                allowBlank: parameter.AllowBlank,
                sortOrder: parameter.SortOrder,
                dynamicValidValues: parameter.DynamicValidValues === 'True',
                dynamicDefaultValue: shouldLoadDynamicDefault,
                usesGenericDate,
                isPortfolioParameter,
                multiValue: parameter.MultiValue === 'True'
            };
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    getReportParameterType = (parameter) => {
        if (parameter.ParamName === 'PortfolioList' || parameter.ParamName === 'PortfolioTest') {
            return 'Dropdown';
        }

        if (parameter.ParamDataType === 'String' && (
            parameter.ValidValues !== '' ||
            parameter.DynamicValidValues === 'True'
        )) {
            return 'Dropdown';
        }

        return parameter.ParamDataType || 'String';
    }

    getReportParameterOptions = (parameter) => {
        if (!parameter.ValidValues) return [];

        try {
            const xml = new DOMParser().parseFromString(parameter.ValidValues, 'text/xml');
            const validValues = Array.from(xml.getElementsByTagName('ValidValue'));

            return validValues.map(validValue => {
                const value = validValue.getElementsByTagName('Value')[0]?.textContent || '';
                const label = validValue.getElementsByTagName('Label')[0]?.textContent || value;
                return { value, label };
            });
        } catch (err) {
            console.error(err);
            return [];
        }
    }

    getPortfolioParameterOptions = () => {
        return this.getPortfolioParameterOptionsFromMappings(this.state.accountMappings);
    }

    getPortfolioParameterOptionsFromMappings = (accountMappings = []) => {
        return accountMappings
            .filter(account => account.accountNumberDisplay)
            .sort((a, b) => {
                const aNum = parseInt(this.getAccountNumber(a.accountNumberDisplay));
                const bNum = parseInt(this.getAccountNumber(b.accountNumberDisplay));

                if (Number.isNaN(aNum) && Number.isNaN(bNum)) return 0;
                if (Number.isNaN(aNum)) return 1;
                if (Number.isNaN(bNum)) return -1;
                if (aNum === bNum) return String(a.accountNumberDisplay).localeCompare(String(b.accountNumberDisplay));
                return aNum - bNum;
            })
            .map(account => ({
                value: account.accountNumberDisplay,
                label: `${account.displayName || 'Account'} #${account.accountNumberDisplay}`
            }));
    }

    getDynamicParameterOptions = async (report, parameter) => {
        if (!this.hasCompanyPortalDatabase()) return [];

        try {
            const response = await fetch(this.buildSsrsQueryUrl('ssrsGetParameterValidValuesQuery', {
                report,
                parameter
            }), {
                method: 'GET',
                headers: this.getRequestHeaders(null)
            });
            const results = await this.parseSsrsResponse(response);
            const values = this.getSsrsResponseData(results);

            if (!Array.isArray(values)) return [];
            return this.normalizeParameterOptions(values, parameter);
        } catch (err) {
            console.error(err);
            return [];
        }
    }

    getDynamicParameterDefaultValue = async (report, parameter) => {
        if (!this.hasCompanyPortalDatabase()) return '';

        try {
            const response = await fetch(this.buildSsrsQueryUrl('ssrsGetParameterDefaultValueQuery', {
                report,
                parameter
            }), {
                method: 'GET',
                headers: this.getRequestHeaders(null)
            });
            const results = await this.parseSsrsResponse(response);
            const values = this.getSsrsResponseData(results);

            if (!Array.isArray(values) || values.length === 0) return '';
            const normalized = this.lowercaseObjectKeys(values[0]);
            return normalized.value || normalized.label || '';
        } catch (err) {
            console.error(err);
            return '';
        }
    }

    parseSsrsResponse = async (response) => {
        const text = await response.text();
        if (!text) return null;

        try {
            return JSON.parse(text);
        } catch (err) {
            return text;
        }
    }

    getSsrsResponseData = (results) => {
        if (results === 'no data') return [];
        if (Array.isArray(results)) return results;
        if (Array.isArray(results?.data)) return results.data;
        return [];
    }

    normalizeParameterOptions = (values, parameterName) => {
        return values.map(value => {
            const normalized = this.lowercaseObjectKeys(value);
            const optionValue = normalized.value || '';
            let label = normalized.label || optionValue;

            if ((parameterName === 'PortfolioList' || parameterName === 'PortfolioTest') && label.includes('|')) {
                label = label.split('|').map(part => part.trim()).join(' | ');
            }

            return {
                value: optionValue,
                label
            };
        });
    }

    lowercaseObjectKeys = (value) => {
        if (!value || typeof value !== 'object') return {};

        return Object.keys(value).reduce((acc, key) => {
            acc[key.toLowerCase()] = value[key];
            return acc;
        }, {});
    }

    getRawReportParameterDefaultValue = (parameter, defaults, dynamicDefaultValue = '') => {
        const defaultFromApi = defaults.find(defaultParameter => (
            defaultParameter.paramName === parameter.ParamName ||
            defaultParameter.ParamName === parameter.ParamName
        ));

        return dynamicDefaultValue
            || defaultFromApi?.value
            || defaultFromApi?.Value
            || parameter.DefaultValues
            || '';
    }

    getReportParameterDefaultValue = (parameter, defaults, options, type, dynamicDefaultValue = '') => {
        const rawValue = this.getRawReportParameterDefaultValue(parameter, defaults, dynamicDefaultValue);

        if (type === 'Boolean') {
            return String(rawValue).toLowerCase() === 'true';
        }

        if (type === 'DateTime') {
            if (String(rawValue).length === 4) return rawValue;
            return this.formatDateForInput(rawValue);
        }

        if (type === 'Dropdown') {
            const matchingOption = options.find(option => option.value === rawValue);
            return matchingOption?.value || rawValue || options[0]?.value || '';
        }

        return rawValue;
    }

    formatDateForInput = (value) => {
        if (!value) return '';

        const stringValue = String(value);
        if (/^\d{4}-\d{2}-\d{2}/.test(stringValue)) {
            return stringValue.slice(0, 10);
        }

        const monthDayYear = stringValue.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{2}|\d{4})$/);
        if (monthDayYear) {
            const month = monthDayYear[1].padStart(2, '0');
            const day = monthDayYear[2].padStart(2, '0');
            const year = monthDayYear[3].length === 2 ? `20${monthDayYear[3]}` : monthDayYear[3];
            return `${year}-${month}-${day}`;
        }

        const parsed = new Date(stringValue);
        if (!Number.isNaN(parsed.getTime())) {
            return parsed.toISOString().slice(0, 10);
        }

        return stringValue;
    }

    updateReportParameterValue = (name, value) => {
        this.setState(prevState => {
            const parameter = prevState.selectedReportParameters.find(item => item.name === name);
            const selectedAccountNumber = parameter?.isPortfolioParameter
                ? (Array.isArray(value) ? value[0] : value)
                : prevState.selectedAccountNumber;

            return {
                selectedAccountNumber,
                selectedReportParameterValues: {
                ...prevState.selectedReportParameterValues,
                [name]: value
                },
                invalidParameters: {
                    ...prevState.invalidParameters,
                    [name]: false
                },
                selectedReportParameters: prevState.selectedReportParameters.map(parameter => (
                    parameter.name === name ? { ...parameter, value } : parameter
                ))
            };
        });
    }

    toggleGenericDateParameter = (name, enabled) => {
        this.setState(prevState => {
            const nextValue = enabled
                ? (prevState.genericDates[0]?.code || '')
                : this.formatDateForInput(prevState.genericDates.find(date => (
                    date.code === prevState.selectedReportParameterValues[name]
                ))?.value || '');

            return {
                genericDateToggles: {
                    ...prevState.genericDateToggles,
                    [name]: enabled
                },
                selectedReportParameterValues: {
                    ...prevState.selectedReportParameterValues,
                    [name]: nextValue
                },
                selectedReportParameters: prevState.selectedReportParameters.map(parameter => (
                    parameter.name === name ? { ...parameter, value: nextValue } : parameter
                ))
            };
        });
    }

    getSelectedReport = () => {
        return this.state.reports.find(report => (
            (report.report || report.name) === this.state.selectedReportName
        ));
    }

    submitSelectedReport = (outputFormat = 'pdf') => {
        const selectedReport = this.getSelectedReport();
        if (!selectedReport) {
            this.setState({
                submitError: 'Select a report before running.',
                submitSuccess: '',
                activeReportName: ''
            });
            return;
        }

        this.submitReport(selectedReport, outputFormat);
    }

    validateSelectedReportParameters = () => {
        const invalidParameters = {};
        const messages = [];

        this.state.selectedReportParameters.forEach(parameter => {
            const value = this.state.selectedReportParameterValues[parameter.name];
            const isBlankArray = Array.isArray(value) && value.length === 0;
            const isBlank = value === '' || value === null || typeof value === 'undefined' || isBlankArray;

            if (String(parameter.allowBlank).toLowerCase() === 'false' && isBlank) {
                invalidParameters[parameter.name] = true;
            }

            if (parameter.name.toLowerCase() === 'filename' && /[<>:"/\\|?*]/.test(String(value || ''))) {
                invalidParameters[parameter.name] = true;
                messages.push('Filename cannot contain: < > : " / \\ | ? *');
            }
        });

        const fromDate = this.state.selectedReportParameterValues.fromDate;
        const toDate = this.state.selectedReportParameterValues.toDate;
        if (fromDate && toDate && !this.state.genericDateToggles.fromDate && !this.state.genericDateToggles.toDate) {
            const fromDateValue = new Date(`${fromDate}T00:00:00`);
            const toDateValue = new Date(`${toDate}T00:00:00`);
            if (!Number.isNaN(fromDateValue.getTime()) && !Number.isNaN(toDateValue.getTime()) && fromDateValue > toDateValue) {
                invalidParameters.fromDate = true;
                invalidParameters.toDate = true;
                messages.push('Begin Date must precede End Date.');
            }
        }

        if (Object.keys(invalidParameters).length > 0) {
            if (Object.values(invalidParameters).some(Boolean) && !messages.some(message => message.startsWith('Highlighted'))) {
                messages.unshift('Highlighted fields must not be blank or invalid.');
            }

            this.setState({
                invalidParameters,
                submitError: messages.join(' ')
            });
            return false;
        }

        this.setState({ invalidParameters: {}, submitError: '' });
        return true;
    }

    hasSelectedPortfolioParameter = () => {
        const portfolioParameter = this.state.selectedReportParameters.find(parameter => parameter.isPortfolioParameter);
        if (!portfolioParameter) return false;

        const value = this.state.selectedReportParameterValues[portfolioParameter.name];
        return Array.isArray(value) ? value.length > 0 : Boolean(value);
    }

    getReportOutputFileName = (database, reportName, dateTime, outputFormat) => {
        return `${database}_${reportName}_${dateTime}.${outputFormat}`;
    }

    buildParameterSubmitData = () => {
        let entityList = '';
        const paramParts = [];

        this.state.selectedReportParameters.forEach(parameter => {
            const value = this.state.selectedReportParameterValues[parameter.name];
            if (value === null || typeof value === 'undefined') return;

            if (parameter.isPortfolioParameter) {
                const values = parameter.multiValue ? (Array.isArray(value) ? value : [value]) : [value];
                entityList = values.filter(Boolean).join('`');
                paramParts.push(`${parameter.name}\`${entityList}`);
                return;
            }

            paramParts.push(`${parameter.name}\`${this.formatParameterValueForSubmit(parameter, value)}`);
        });

        return {
            paramString: paramParts.join('|'),
            entityList,
            layout: this.state.selectedReportParameterValues.Layout || null
        };
    }

    formatParameterValueForSubmit = (parameter, value) => {
        if (parameter.type === 'Boolean') {
            return value ? 'True' : 'False';
        }

        if (parameter.type === 'DateTime') {
            if (this.state.genericDateToggles[parameter.name]) {
                const genericDate = this.state.genericDates.find(date => date.code === value || date.label === value);
                return this.formatDateForSsrs(genericDate?.value || value);
            }

            return this.formatDateForSsrs(value);
        }

        return value;
    }

    formatDateForSsrs = (value) => {
        if (!value) return '';

        const formattedInputDate = this.formatDateForInput(value);
        const date = new Date(`${formattedInputDate}T00:00:00`);
        if (Number.isNaN(date.getTime())) return value;

        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${month}-${day}-${date.getFullYear()}`;
    }

    buildPayload = (report, outputFormat = 'pdf') => {
        const ssrsDatabase = this.getSsrsDatabase();
        const dateTime = this.getDateTime();
        const email = this.getCurrentUserEmail();
        const reportName = report?.report;
        const parameterSubmitData = this.buildParameterSubmitData();
        const hasSelectedParameters = this.state.selectedReportParameters.length > 0;

        if (!hasSelectedParameters /*&& reportName === PORTFOLIO_SUMMARY_REPORT*/) {
            const selectedAccount = this.state.selectedAccountNumber;

            return {
                id: `${ssrsDatabase}_${email}_${dateTime}`,
                paramString: [
                    `PortfolioList\`${selectedAccount}`,
                    'IncludePortfolioCode`True',
                    'IncludeAI`True',
                    'UnsupervisedAssets`1',
                    `ReportTitle\`${PORTFOLIO_SUMMARY_REPORT}`,
                    'Layout`l',
                    'Disclaimer`No Disclaimer',
                    `singleDate\`${PORTFOLIO_SUMMARY_SINGLE_DATE}`
                ].join('|'),
                report: PORTFOLIO_SUMMARY_REPORT,
                folder: report?.folder,
                database: ssrsDatabase,
                fileName: this.getReportOutputFileName(ssrsDatabase, PORTFOLIO_SUMMARY_REPORT, dateTime, outputFormat),
                dateTime: dateTime,
                outputFormat,
                layout: 'l',
                entityList: selectedAccount
            };
        }

        return {
            dateTime: dateTime,
            entityList: hasSelectedParameters ? parameterSubmitData.entityList : '',
            fileName: this.getReportOutputFileName(ssrsDatabase, reportName, dateTime, outputFormat),
            folder: report?.folder,
            id: `${ssrsDatabase}_${email}_${dateTime}`,
            database: ssrsDatabase,
            layout: hasSelectedParameters ? parameterSubmitData.layout : null,
            outputFormat,
            paramString: hasSelectedParameters ? parameterSubmitData.paramString : null,
            report: reportName
        };
    }

    buildBlobPayload = (payload) => {
        return {
            id: payload.id,
            fileName: payload.fileName,
            reportName: payload.report,
            databaseName: payload.database,
            commandDate: payload.dateTime
        };
    }

    submitReport = async (report, outputFormat = 'pdf') => {
        const email = this.getCurrentUserEmail();

        if (!this.getHeaderDatabase() || !this.getSsrsDatabase() || !this.hasCompanyPortalDatabase() || !email) {
            this.setState({
                submitError: 'Missing portal database or logged in user email.',
                submitSuccess: '',
                activeReportName: report?.report || ''
            });
            return;
        }

        if (report?.requiresAccount && !this.state.selectedAccountNumber && !this.hasSelectedPortfolioParameter()) {
            this.setState({
                submitError: 'Select an account before running this report.',
                submitSuccess: '',
                activeReportName: report?.report || ''
            });
            return;
        }

        if (this.state.selectedReportParametersLoading) {
            this.setState({
                submitError: 'Wait for report parameters to finish loading.',
                submitSuccess: '',
                activeReportName: report?.report || ''
            });
            return;
        }

        if (this.state.selectedReportParameters.length > 0 && !this.validateSelectedReportParameters()) {
            this.setState({
                submitSuccess: '',
                activeReportName: report?.report || ''
            });
            return;
        }

        this.setState({
            submitLoading: true,
            pollLoading: false,
            submitError: '',
            submitSuccess: '',
            status: '',
            activeReportName: report?.report || '',
            pdfUrl: null,
            pdfFileName: ''
        });

        try {
            const payload = this.buildPayload(report, outputFormat);
            const blobPayload = this.buildBlobPayload(payload);

            const response = await fetch(SSRS_REPORT_ENDPOINT, {
                method: 'POST',
                headers: this.getRequestHeaders(),
                body: JSON.stringify(payload)
            });

            const contentType = (response.headers.get('content-type') || '').toLowerCase();
            const results = contentType.includes('application/json')
                ? await response.json()
                : await response.text();

            if (!response.ok || results?.success === false || results?.debug_message != null) {
                throw new Error(results?.message || results?.debug_message || `HTTP ${response.status}`);
            }

            this.setState({
                // submitSuccess: 'SSRS report submitted. Waiting for the finished PDF.',
                pollLoading: true,
                status: 'Generating report...',
                submitError: ''
            }, () => this.startBlobPolling(blobPayload, payload.outputFormat));
        } catch (err) {
            this.setState({
                submitError: err.message || 'Unable to submit SSRS report.',
                submitSuccess: ''
            });
        } finally {
            this.setState({
                submitLoading: false
            });
        }
    }

    startBlobPolling = (payload, outputFormat) => {
        this.clearBlobPolling();

        let count = 0;
        this.checkPdfBlobTimerId = setInterval(async () => {
            const result = await this.checkBlob(payload);

            if (result?.errorMessage) {
                this.clearBlobPolling();
                this.setState({
                    submitError: result.errorMessage,
                    submitSuccess: '',
                    status: '',
                    pollLoading: false
                });
                return;
            }

            if (result === true) {
                this.clearBlobPolling();
                this.getBlob(payload, outputFormat);
                return;
            }

            count += 1;
            if (count === 10) {
                this.setState({ status: 'Still generating report...' });
            }

            if (count > MAX_POLL_ATTEMPTS) {
                this.clearBlobPolling();
                this.setState({
                    submitError: 'There was an error creating the report.',
                    submitSuccess: '',
                    status: '',
                    pollLoading: false
                });
            }
        }, POLL_INTERVAL_MS);
    }

    checkBlob = async (payload) => {
        if (!this.hasCompanyPortalDatabase()) {
            return { errorMessage: 'Missing portal database.' };
        }

        try {
            const params = new URLSearchParams({
                id: payload.id,
            });
            const response = await fetch(`${SSRS_BLOB_ENDPOINT}?${params.toString()}`, {
                method: 'GET',
                headers: this.getRequestHeaders(null)
            });

            if (!response.ok) {
                return { errorMessage: `HTTP ${response.status}` };
            }

            const contentType = (response.headers.get('content-type') || '').toLowerCase();
            if (contentType.includes('application/json')) {
                const results = await response.json();
                if (results === 'no data' || results?.data === 'no data') return false;
                if (results?.errorMessage) return results;
                return true;
            }

            const text = await response.clone().text();
            if (text === 'no data') return false;
            if (text) {
                try {
                    const results = JSON.parse(text);
                    if (results?.errorMessage) return results;
                } catch (err) {
                    return true;
                }
            }

            return true;
        } catch (err) {
            return { errorMessage: err.message || 'Unable to check report status.' };
        }
    }

    getBlob = async (payload, outputFormat) => {
        if (!this.hasCompanyPortalDatabase()) {
            this.setState({
                submitError: 'Missing portal database.',
                submitSuccess: '',
                pollLoading: false,
                submitLoading: false
            });
            return;
        }

        const responseTypes = {
            pdf: 'application/pdf',
            xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            csv: 'application/csv'
        };

        try {
            const params = new URLSearchParams({
                id: payload.id
            });
            const response = await fetch(`${SSRS_BLOB_ENDPOINT}?${params.toString()}`, {
                method: 'GET',
                headers: {
                    ...this.getRequestHeaders(null),
                    'Accept': responseTypes[outputFormat] || responseTypes.pdf
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            const blob = await response.blob();
            const validationError = await this.getBlobValidationError(blob, outputFormat);
            if (validationError) throw new Error(validationError);

            const file = new Blob([blob], { type: responseTypes[outputFormat] || responseTypes.pdf });
            const fileUrl = window.URL.createObjectURL(file);

            if (this.state.pdfUrl) window.URL.revokeObjectURL(this.state.pdfUrl);

            this.setState({
                pdfUrl: fileUrl,
                pdfFileName: payload.fileName,
                pollLoading: false,
                status: '',
                // submitSuccess: 'SSRS report is ready.',
                submitError: ''
            }, () => {
                if (outputFormat === 'pdf') {
                    window.open(fileUrl, '_blank', 'noopener,noreferrer');
                } else {
                    this.saveFile(file, payload.fileName);
                }
                this.deleteBlob(payload);
            });
        } catch (err) {
            this.setState({
                submitError: err.message || 'Unable to retrieve the finished report.',
                submitSuccess: '',
                status: '',
                pollLoading: false
            });
        }
    }

    getBlobValidationError = async (blob, outputFormat) => {
        const textBlob = blob.slice(0, 1000);
        const text = await textBlob.text();
        const trimmedText = text.trim();

        if (trimmedText === 'no data') return 'The report is not ready yet.';

        if (trimmedText.startsWith('{') || trimmedText.startsWith('[')) {
            try {
                const results = JSON.parse(trimmedText);
                return results?.errorMessage || results?.message || 'The report endpoint returned JSON instead of a PDF.';
            } catch (err) {
                return 'The report endpoint returned JSON instead of a PDF.';
            }
        }

        if (/^<!doctype html/i.test(trimmedText) || /^<html/i.test(trimmedText)) {
            return 'The report endpoint returned HTML instead of a PDF. Check the SSRS blob endpoint URL.';
        }

        if (outputFormat === 'pdf' && !text.startsWith('%PDF')) {
            return 'The finished report response was not a valid PDF.';
        }

        return '';
    }

    deleteBlob = async (params) => {
        if (!this.hasCompanyPortalDatabase()) return;

        try {
            await fetch(SSRS_DELETE_BLOB_ENDPOINT, {
                method: 'POST',
                headers: this.getRequestHeaders(),
                body: JSON.stringify({
                    filename: params.fileName,
                    reportName: params.reportName,
                    databaseName: params.databaseName,
                    id: params.id
                })
            });
        } catch (err) {
            console.error(err);
        }
    }

    renderReportStatus = () => {
        if (this.state.submitError !== '') {
            return (
                <Alert color="danger" className="mb-0 py-2 d-inline-block">
                    {this.state.submitError}
                </Alert>
            );
        }

        const message = this.state.status || this.state.submitSuccess;
        if (message !== '') {
            return (
                <Alert
                    color={this.state.pdfUrl ? 'success' : 'info'}
                    className={`mb-0 py-2 d-inline-block ${this.state.pdfUrl ? '' : 'bg-white border-info text-info'}`}
                >
                    {message}
                </Alert>
            );
        }

        return null;
    }

    renderReportToolbar = () => {
        const controlsDisabled = !this.state.selectedReportName
            || this.state.selectedReportParametersLoading
            || this.state.submitLoading
            || this.state.pollLoading;

        return (
            <Row className="py-4 align-items-center">
                <Col md={6} className="text-left">
                    <span className='font-weight-bold mr-2'>Run Selected Report:</span>
                    <Button
                        color="success"
                        className="mr-2"
                        disabled={controlsDisabled}
                        onClick={() => this.submitSelectedReport('pdf')}
                        title="Run Selected Report"
                    >
                        {/* <FontAwesomeIcon icon={faPlay} />  */}
                        PDF
                    </Button>
                    <Button
                        color="secondary"
                        className="mr-2"
                        disabled={controlsDisabled}
                        onClick={() => this.submitSelectedReport('xlsx')}
                        title="Run Selected Report as Excel"
                    >
                        XLSX
                    </Button>
                    <Button
                        color="secondary"
                        disabled={controlsDisabled}
                        onClick={() => this.submitSelectedReport('csv')}
                        title="Run Selected Report as CSV"
                    >
                        CSV
                    </Button>
                </Col>
                <Col md={6} className="text-right">
                    <div className="d-flex justify-content-end align-items-center">
                        {this.renderReportStatus()}
                        {this.state.pdfUrl && (
                            <a
                                href={this.state.pdfUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-primary ml-2"
                            >
                                Open PDF
                            </a>
                        )}
                    </div>
                </Col>
            </Row>
        );
    }

    renderReportParameterInput = (parameter) => {
        const value = this.state.selectedReportParameterValues[parameter.name];
        const inputDisabled = this.state.submitLoading || this.state.pollLoading;

        if (parameter.type === 'Boolean') {
            return (
                <Input
                    type="checkbox"
                    id={`ssrs-param-${parameter.name}`}
                    name={parameter.name}
                    checked={Boolean(value)}
                    invalid={Boolean(this.state.invalidParameters[parameter.name])}
                    disabled={inputDisabled}
                    onChange={event => this.updateReportParameterValue(parameter.name, event.target.checked)}
                    className='ml-1 mt-0'
                />
            );
        }

        if (parameter.type === 'Dropdown') {
            return (
                <Input
                    type="select"
                    multiple={parameter.isPortfolioParameter && parameter.multiValue}
                    id={`ssrs-param-${parameter.name}`}
                    name={parameter.name}
                    value={parameter.isPortfolioParameter && parameter.multiValue ? (Array.isArray(value) ? value : []) : (value || '')}
                    invalid={Boolean(this.state.invalidParameters[parameter.name])}
                    onChange={event => {
                        const nextValue = parameter.isPortfolioParameter && parameter.multiValue
                            ? Array.from(event.target.selectedOptions).map(option => option.value)
                            : event.target.value;
                        this.updateReportParameterValue(parameter.name, nextValue);
                    }}
                    disabled={inputDisabled || parameter.options.length === 0}
                >
                    {parameter.allowBlank === 'True' && <option value=""> </option>}
                    {parameter.options.length === 0 && <option value={value || ''}>{value || 'No values available'}</option>}
                    {parameter.options.map(option => (
                        <option key={`${parameter.name}-${option.value}`} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </Input>
            );
        }

        if (parameter.type === 'DateTime' && this.state.genericDateToggles[parameter.name]) {
            return (
                <div className="d-flex">
                    <Input
                        type="select"
                        id={`ssrs-param-${parameter.name}`}
                        name={parameter.name}
                        value={value || ''}
                        invalid={Boolean(this.state.invalidParameters[parameter.name])}
                        disabled={inputDisabled}
                        onChange={event => this.updateReportParameterValue(parameter.name, event.target.value)}
                    >
                        {this.state.genericDates.map(date => (
                            <option key={`${parameter.name}-${date.code}`} value={date.code}>
                                {date.label}
                            </option>
                        ))}
                    </Input>
                    <Button
                        color="secondary"
                        // outline
                        className="ml-2"
                        disabled={inputDisabled}
                        onClick={() => this.toggleGenericDateParameter(parameter.name, false)}
                    >
                        Date
                    </Button>
                </div>
            );
        }

        return (
            <div className={parameter.type === 'DateTime' ? 'd-flex' : ''}>
                <Input
                    type={parameter.type === 'DateTime' ? 'date' : 'text'}
                    id={`ssrs-param-${parameter.name}`}
                    name={parameter.name}
                    value={value || ''}
                    invalid={Boolean(this.state.invalidParameters[parameter.name])}
                    disabled={inputDisabled}
                    onChange={event => this.updateReportParameterValue(parameter.name, event.target.value)}
                />
                {parameter.type === 'DateTime' && this.state.genericDates.length > 0 && (
                    <Button
                        color="secondary"
                        // outline
                        className="ml-2"
                        disabled={inputDisabled}
                        onClick={() => this.toggleGenericDateParameter(parameter.name, true)}
                    >
                        Generic
                    </Button>
                )}
            </div>
        );
    }

    renderSelectedReportParameters = () => {
        if (!this.state.selectedReportName) {
            return null;
        }

        if (this.state.selectedReportParametersLoading) {
            return (
                <h4 className="mb-0 text-center">
                    Loading report parameters...
                </h4>
            );
        }

        if (this.state.selectedReportParametersError) {
            return (
                <Alert color="danger" className="mb-0">
                    {this.state.selectedReportParametersError}
                </Alert>
            );
        }

        if (this.state.selectedReportParameters.length === 0) {
            return (
                <Alert color="info" className="mb-0 bg-white border-info text-info">
                    No parameters returned for this report.
                </Alert>
            );
        }

        return (
            <div className="text-left" style={{ textAlign: 'left' }}>
                {this.state.selectedReportParameters.map(parameter => (
                    <FormGroup key={parameter.name} row className="align-items-center mb-2">
                        <Label for={`ssrs-param-${parameter.name}`} sm={4} className="mb-0 text-left" style={{ textAlign: 'left' }}>
                            {parameter.label}
                        </Label>
                        <Col sm={8} className="text-left" style={{ textAlign: 'left' }}>
                            {this.renderReportParameterInput(parameter)}
                        </Col>
                    </FormGroup>
                ))}
            </div>
        );
    }

    saveFile = (blob, filename) => {
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
            return;
        }

        const link = document.createElement('a');
        document.body.appendChild(link);
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = filename;
        link.click();
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        }, 0);
    }

    getReportRowProps = (state, rowInfo) => {
        const report = rowInfo?.original;
        const reportName = report?.report || report?.name || '';
        const disabled = !reportName || this.state.submitLoading || this.state.pollLoading;

        return {
            onClick: event => {
                if (disabled || event.target.closest('a, button, input, select, textarea')) return;
                this.selectReport(report);
            },
            style: {
                backgroundColor: reportName === this.state.selectedReportName ? '#007bff' : undefined,
                color: reportName === this.state.selectedReportName ? '#fff' : undefined,
                cursor: disabled ? 'default' : 'pointer'
            }
        };
    }

    getAccountRowProps = (state, rowInfo) => {
        const accountNumber = this.getAccountNumber(rowInfo?.original?.account);
        const selectionValue = rowInfo?.original?.accountNumberDisplay || accountNumber;

        return {
            onClick: event => {
                if (!selectionValue || event.target.closest('a, button, input, select, textarea')) return;
                this.selectAccountNumber(selectionValue);
            },
            style: {
                cursor: selectionValue ? 'pointer' : 'default'
            }
        };
    }

    renderReportList = () => {
        if (this.state.reportsIsLoading) {
            return (
                <h4 className="py-4 text-center text-muted">
                    Loading reports...
                </h4>
            );
        }

        return (
            <ReactTable
                data={this.state.reports}
                columns={this.reportColumns}
                defaultColumn={this.defaultColumn}
                getTheadThProps={this.leftAlignedHeaderProps}
                getTdProps={this.leftAlignedCellProps}
                getTrProps={this.getReportRowProps}
                pageSize={this.state.reports.length}
                showPagination={false}
                className="ssrs-report-list-table"
            />
        );
    }

    shouldShowReportControls = () => {
        return !this.state.reportsIsLoading
            && Boolean(this.state.selectedReportName)
            && !this.state.selectedReportParametersLoading;
    }

    render() {
        return (
            <PermissionWrapper {...this.props} allowedPermission="Reports">
                <Container fluid className='p-9'>
                    <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
                        <Row>
                            <Col md={12} className='text-center'>
                                <h1>{this.props.title}</h1>
                            </Col>
                        </Row>
                    </PermissionWrapper>
                    {this.state.submitError !== '' && this.state.activeReportName === '' && <Alert color="danger">{this.state.submitError}</Alert>}
                    <Row>
                        <Col md={4} className='pt-4'>
                            {this.renderReportList()}
                        </Col>
                        <Col className="text-left" style={{ textAlign: 'left' }}>
                            {this.shouldShowReportControls() && this.renderReportToolbar()}
                            {!this.state.reportsIsLoading && this.renderSelectedReportParameters()}
                            {/* <ReactTable
                                data={this.state.accountMappings}
                                columns={this.accountMappingColumns}
                                defaultColumn={this.defaultColumn}
                                getTheadThProps={this.leftAlignedHeaderProps}
                                getTdProps={this.leftAlignedCellProps}
                                getTrProps={this.getAccountRowProps}
                                loading={this.state.accountMappingsLoading}
                                defaultFilterMethod={filterCaseInsensitive}
                                pageSize={this.state.accountMappingsPageSize}
                                onPageSizeChange={this.setAccountMappingsPageSize}
                                pageSizeOptions={[10, 20, 50, 100, 250]}
                                showPageSizeOptions={true}
                                defaultSorted={[{ id: 'accountNumber', desc: false }]}
                                minRows={0}
                                noDataText={this.state.accountMappingsLoading ? 'Loading account mappings...' : 'No households available'}
                                className="mb-4"
                            /> */}
                        </Col>
                    </Row>
                </Container>
            </PermissionWrapper>
        );
    }
}

export default SSRSReports;
